import { render, staticRenderFns } from "./VideoModule.vue?vue&type=template&id=eba0c8e6&scoped=true&"
import script from "./VideoModule.vue?vue&type=script&lang=js&"
export * from "./VideoModule.vue?vue&type=script&lang=js&"
import style0 from "./VideoModule.vue?vue&type=style&index=0&id=eba0c8e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba0c8e6",
  null
  
)

export default component.exports